import HomeIcon from "../../assets/icons/Home";
import SquaresFilled from "../../assets/icons/SquaresFilled";
import Users from "../../assets/icons/Users";
import BuildingSkyscraper from "../../assets/icons/BuildingSkyscraper";
import MapPins from "../../assets/icons/MapPins";
import MapSearch from "../../assets/icons/MapSearch";
import ListDetails from "../../assets/icons/ListDetails";
const sidebarItemIconSize = 22;
const Menu = [
  {
    name: "HomePage",
    title: "Home Page",
    icon: <HomeIcon size={sidebarItemIconSize} />,
    path: "/dashboard",
  },
  {
    name: "Advertisements",
    title: "Advertisements",
    icon: <SquaresFilled size={sidebarItemIconSize} />,
    path: "/advertisements",
  },
  {
    name: "Properties",
    title: "Properties",
    icon: <MapSearch size={sidebarItemIconSize} />,
    path: "/properties",
  },
  {
    name: "AgentsRequests",
    title: "Agents Requests",
    icon: <Users size={sidebarItemIconSize} />,
    path: "/agents-requests",
  },
  {
    name: "Companies",
    title: "Companies",
    icon: <BuildingSkyscraper size={sidebarItemIconSize} />,
    path: "/companies",
  },
  {
    name: "PropertiesRequests",
    title: "Properties Requests",
    icon: <MapPins size={sidebarItemIconSize} />,
    path: "/properties-requests",
  },
  // {
  //   name: "Requests",
  //   title: "Requests",
  //   icon: <BuildingSkyscraper size={sidebarItemIconSize} />,
  //   path: "/requests",
  //   subMenu: [
  //     {
  //       name: "Accounts",
  //       title: "Properties Requests",
  //       path: "/dashboard14",
  //     },
  //     {
  //       name: "Accounts",
  //       title: "Agents Requests",
  //       path: "/dashboard15",
  //     },
  //     {
  //       name: "Accounts",
  //       title: "Accounts3",
  //       path: "/dashboard16",
  //     },
  //   ],
  // },
];
export default Menu;
